module.exports = __webpack_public_path__ + "img/sjz.821a521e.png";